module.exports = __webpack_public_path__ + "img/customer-icon-5.c15b5bdd.png";